import React from 'react';

function MarshallIslands(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124060)">
        <mask
          id="mask0_800_124060"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124060)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#3D58DB"
          />
          <mask
            id="mask1_800_124060"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124060)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9 11L8.08087 13.9441L8.08944 10.8888L6.31079 13.5033L7.2464 10.5633L4.74016 12.6543L6.53343 10.0477L3.48545 11.4601L6.00339 9.3802L2.63974 10.0093L5.69559 8.61037L2.26574 8.40945L5.63287 7.79527L2.39118 6.77926L5.81987 6.99536L3.00677 5.23961L6.24273 6.26996L4.06686 3.90468L6.87008 5.67287L5.49281 2.87348L7.6554 5.24837L7.17887 2.2225L8.54044 5.02794L9 2L9.45956 5.02794L10.8211 2.2225L10.3446 5.24837L12.5072 2.87348L11.1299 5.67287L13.9331 3.90468L11.7573 6.26996L14.9932 5.23961L12.1801 6.99536L15.6088 6.77926L12.3671 7.79527L15.7343 8.40945L12.3044 8.61037L15.3603 10.0093L11.9966 9.3802L14.5145 11.4601L11.4666 10.0477L13.2598 12.6543L10.7536 10.5633L11.6892 13.5033L9.91056 10.8888L9.91913 13.9441L9 11Z"
              fill="#F7FCFF"
            />
            <path
              d="M-0.879883 24.7453L37.4154 1.21484V8.8856L-0.879883 24.7453Z"
              fill="white"
            />
            <path
              d="M-0.879883 24.7453L37.4154 -4.78516V2.8856L-0.879883 24.7453Z"
              fill="#E2AE57"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124060">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default MarshallIslands;
